import React, { ReactNode, createContext, useReducer, useEffect, useContext } from 'react';

import { AccountContextData, AuthReducer, initialState } from './reducer';
import { fetchUserAccount } from './actions';
import { trackEdgeExperiments } from '../../utils/trackEdgeExperiment';

interface AuthProviderProps {
  children: ReactNode;
}

const AuthStateContext = createContext(initialState);
const AuthDispatchContext = createContext({});

export function useAuthState(): AccountContextData {
  const context = useContext(AuthStateContext);
  if (context === undefined) {
    throw new Error('useAuthState must be used within a AuthProvider');
  }

  return context;
}

export function useAuthDispatch() {
  const context = useContext(AuthDispatchContext);
  if (context === undefined) {
    throw new Error('useAuthDispatch must be used within a AuthProvider');
  }

  return context;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [account, dispatch] = useReducer(AuthReducer, initialState);
  useEffect(() => {
    fetchUserAccount(dispatch);
  }, []);

  useEffect(() => {
    if (!account.loaded) return;
    trackEdgeExperiments(account.accountInfo?.id);
  }, [account]);

  return (
    <AuthStateContext.Provider value={account}>
      <AuthDispatchContext.Provider value={dispatch}>{children}</AuthDispatchContext.Provider>
    </AuthStateContext.Provider>
  );
};
